import { gql } from '@apollo/client';
import { useQuery } from '@/hooks/apollo/useQuery';
import { days } from '@techminds/react-calendar';

import { GetHolidaysQuery, GetHolidaysQueryVariables } from '@/types/apollo';
import { DEFAULT_DATE_FORMAT } from '@pkgtour-workspace/common/dist/constants/date';

interface UseHolidaysOptions {
  startDate?: string;
  endDate?: string;
}

export const useHolidays = ({ startDate: _startDate, endDate: _endDate }: UseHolidaysOptions = {}) => {
  const startMonth = days().startOf('month');
  const endMonth = startMonth.add(1, 'year').endOf('month');

  const { data } = useQuery<GetHolidaysQuery, GetHolidaysQueryVariables>(localQuery, {
    variables: {
      startDate: _startDate || startMonth.format(DEFAULT_DATE_FORMAT),
      endDate: _endDate || endMonth.format(DEFAULT_DATE_FORMAT),
    },
  });

  return data?.commonHolidays || [];
};

const localQuery = gql`
  query getHolidays($startDate: String!, $endDate: String!) {
    commonHolidays(startDate: $startDate, endDate: $endDate) {
      id
      name
      date
      type
    }
  }
`;
